/** My Results — full Admin only (not VAdmin, VAdmin+, or Max). */
export function hasMyResultsAccess({ isAdmin }) {
  return Boolean(isAdmin);
}

/**
 * My Portfolio / Client Reporting — Pro tier and up. Basic users see the nav
 * with a Pro badge and an upgrade gate on the page.
 */
export function hasClientReportingAccess({
  isSignedIn,
  isPro,
  isAdmin,
  isVectorAdmin,
  isMax,
  isBeta,
}) {
  if (!isSignedIn && !isAdmin && !isVectorAdmin && !isMax) return false;
  return Boolean(isPro || isMax || isAdmin || isVectorAdmin || isBeta);
}

/** Cross-user Client Reporting — all accounts overview and account picker. */
export function isClientReportingElevated({ isAdmin, isVectorAdmin, isMax }) {
  return Boolean(isAdmin || isVectorAdmin || isMax);
}
